"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unnecessary-condition -- Wrong typing, ownerState can be null */ var styleOverrides = {
    root: function(param) {
        var theme = param.theme, ownerState = param.ownerState;
        var _ownerState_color, _ref, _ownerState_color1, _ref1, _ownerState_color2, _ref2, _ownerState_color3, _ref3;
        return _object_spread(_define_property({
            padding: '10px 15px '
        }, theme.breakpoints.up('sm'), {
            padding: '10px 30px '
        }), (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === 'standard' && _define_property({
            backgroundColor: _constants.colors.lightItem[(_ref = (_ownerState_color = ownerState.color) !== null && _ownerState_color !== void 0 ? _ownerState_color : ownerState.severity) !== null && _ref !== void 0 ? _ref : 'info'].background,
            color: _constants.colors.lightItem[(_ref1 = (_ownerState_color1 = ownerState.color) !== null && _ownerState_color1 !== void 0 ? _ownerState_color1 : ownerState.severity) !== null && _ref1 !== void 0 ? _ref1 : 'info'].textAlert,
            borderColor: _constants.colors.lightItem[(_ref2 = (_ownerState_color2 = ownerState.color) !== null && _ownerState_color2 !== void 0 ? _ownerState_color2 : ownerState.severity) !== null && _ref2 !== void 0 ? _ref2 : 'info'].background
        }, "& .".concat(_material.alertClasses.icon), {
            color: _constants.colors.lightItem[(_ref3 = (_ownerState_color3 = ownerState.color) !== null && _ownerState_color3 !== void 0 ? _ownerState_color3 : ownerState.severity) !== null && _ref3 !== void 0 ? _ref3 : 'info'].textAlert
        }), (ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === 'default' && (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === 'filled' && {
            backgroundColor: _constants.colors.defaultColors.main,
            color: _constants.colors.defaultColors.contrastText,
            borderColor: _constants.colors.defaultColors.main
        });
    },
    filledSuccess: {
        backgroundColor: _constants.colors.success.light,
        color: _constants.colors.text.primary
    },
    message: function(param) {
        var theme = param.theme;
        return {
            alignContent: 'center',
            fontSize: theme.typography.body1.fontSize,
            padding: '10px 0'
        };
    },
    icon: function(param) {
        var theme = param.theme;
        return {
            fontSize: '2.4rem',
            lineHeight: 1,
            opacity: '1',
            padding: '7.5px 0',
            marginRight: '10px'
        };
    }
};
var defaultProps = {
    severity: 'info',
    iconMapping: {
        error: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.ErrorCircle, {
            fontSize: "inherit"
        }),
        info: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.InfoCircle, {
            fontSize: "inherit"
        }),
        default: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.InfoCircle, {
            fontSize: "inherit"
        }),
        success: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.CheckCircle, {
            fontSize: "inherit"
        }),
        warning: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Warning, {
            fontSize: "inherit"
        })
    }
};
var _default = exports.default = {
    defaultProps: defaultProps,
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiAlert.js.map
